export enum NotificationStatus {
  OPEN = 'OPEN',
  RESOLVED = 'RESOLVED',
}
